import { render, staticRenderFns } from "./clientdashboard-profile-ouders.vue?vue&type=template&id=d57af972&"
import script from "./clientdashboard-profile-ouders.vue?vue&type=script&lang=js&"
export * from "./clientdashboard-profile-ouders.vue?vue&type=script&lang=js&"
import style0 from "./clientdashboard-profile-ouders.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports